import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
const events = [{
  id: 1,
  date: 'OCT 24',
  day: 'FRIDAY',
  artist: 'LIL WAYNE',
  type: 'LIVE IN CONCERT',
  image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 2,
  date: 'OCT 25',
  day: 'SATURDAY',
  artist: 'RICK ROSS',
  type: 'RESIDENCY',
  image: 'https://images.unsplash.com/photo-1493225255756-d9584f8606e9?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 3,
  date: 'OCT 26',
  day: 'SUNDAY',
  artist: 'SWIM NIGHT',
  type: 'NIGHT SWIM',
  image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 4,
  date: 'OCT 31',
  day: 'THURSDAY',
  artist: 'HALLOWEEN',
  type: 'SPECIAL EVENT',
  image: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?q=80&w=2070&auto=format&fit=crop'
}];
export function EventsSection() {
  return <section id="events" className="py-24 bg-[#0B1014] relative" data-id="element-251">
      <div className="container mx-auto px-6" data-id="element-252">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-253">
          <div data-id="element-254">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-2 tracking-wide" data-id="element-255">
              UPCOMING EVENTS
            </h2>
            <p className="text-[#DDA247] text-lg tracking-widest uppercase" data-id="element-256">
              Experience the best in nightlife
            </p>
          </div>
          <Link to="/events" data-id="element-257">
            <Button variant="outline" className="mt-6 md:mt-0" data-id="element-258">
              VIEW FULL CALENDAR
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-259">
          {events.map((event, index) => <motion.div key={event.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-[#11161A] border border-white/5 hover:border-[#DDA247]/50 transition-colors duration-300" data-id="element-260">
              <div className="relative h-64 overflow-hidden" data-id="element-261">
                <div className="absolute top-4 left-4 bg-[#DDA247] text-[#0B1014] px-3 py-1 font-bold text-sm z-20" data-id="element-262">
                  {event.date}
                </div>
                <img src={event.image} alt={event.artist} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-263" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014] to-transparent opacity-80" data-id="element-264" />
              </div>

              <div className="p-6" data-id="element-265">
                <div className="text-[#DDA247] text-xs font-bold tracking-widest mb-2" data-id="element-266">
                  {event.type}
                </div>
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-267">
                  {event.artist}
                </h3>
                <p className="text-gray-400 text-sm mb-6" data-id="element-268">
                  {event.day} • 10:00 PM
                </p>
                <Link to="/bottle-service" data-id="element-269">
                  <Button variant="primary" fullWidth size="sm" data-id="element-270">
                    TICKETS
                  </Button>
                </Link>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}